"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _confirmWithdrawActions = require("../../redux/actions/confirmWithdrawActions");
var _queryParamsHelper = require("../../helpers/queryParamsHelper");
var _VerifyAddressComponent = _interopRequireDefault(require("./VerifyAddressComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var processingVerifyAddress = state.apiProcessing.processingVerifyAddress,
    _state$verifyAddress = state.verifyAddress,
    message = _state$verifyAddress.message,
    error = _state$verifyAddress.error;
  return {
    processingVerifyAddress: processingVerifyAddress,
    message: message,
    error: error
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var d1 = (0, _queryParamsHelper.getQueryParam)('d1');
  var AccountId = (0, _queryParamsHelper.getQueryParam)('AccountId');
  var verifycode = (0, _queryParamsHelper.getQueryParam)('verifycode');
  return {
    verifyAddress: function verifyAddress() {
      return dispatch((0, _confirmWithdrawActions.verifyAddress)({
        verifycode: verifycode,
        AccountId: AccountId,
        d1: d1
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VerifyAddressComponent["default"]);